import { render, staticRenderFns } from "./GoalDetailPanel.vue?vue&type=template&id=444683d8&scoped=true&"
import script from "./GoalDetailPanel.vue?vue&type=script&lang=js&"
export * from "./GoalDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./GoalDetailPanel.vue?vue&type=style&index=0&id=444683d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444683d8",
  null
  
)

/* custom blocks */
import block0 from "./GoalDetailPanel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('444683d8')) {
      api.createRecord('444683d8', component.options)
    } else {
      api.reload('444683d8', component.options)
    }
    module.hot.accept("./GoalDetailPanel.vue?vue&type=template&id=444683d8&scoped=true&", function () {
      api.rerender('444683d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goal/GoalDetailPanel.vue"
export default component.exports